import { useState } from "react";
import { integrationActivityLog } from "@/mocks/integrationsData";

export function IntegrationActivityTable() {
  const [sourceFilter, setSourceFilter] = useState("All Sources");
  const [typeFilter, setTypeFilter] = useState("All");
  const [visibleCount, setVisibleCount] = useState(10);

  const sources = [
    "All Sources",
    "IndiaMart",
    "JustDial",
    "WhatsApp",
    "Website",
    "Exotel",
    "TradeIndia",
  ];

  const types = ["All", "Lead Received", "Webhook", "Error", "Sync"];

  const filtered = integrationActivityLog.filter((entry) => {
    if (sourceFilter !== "All Sources" && entry.source !== sourceFilter) return false;
    if (typeFilter !== "All" && entry.event !== typeFilter) return false;
    return true;
  });

  const visible = filtered.slice(0, visibleCount);

  return (
    <div className="bg-white rounded-xl border border-[#e5e7eb] p-5">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <div>
          <h3 className="text-lg font-semibold text-[#111827]">Integration Activity Log</h3>
          <p className="text-sm text-[#6b7280] mt-0.5">Recent events from all integrations</p>
        </div>
        <a
          href="#"
          className="text-sm text-indigo-600 hover:text-indigo-700 font-medium whitespace-nowrap"
        >
          View All
        </a>
      </div>

      {/* Filter row */}
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <select
          value={sourceFilter}
          onChange={(e) => setSourceFilter(e.target.value)}
          className="border border-gray-200 rounded-lg px-3 py-2 text-sm text-[#374151] bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
          {sources.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        <select
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          className="border border-gray-200 rounded-lg px-3 py-2 text-sm text-[#374151] bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
          {types.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left text-xs font-medium text-[#6b7280] uppercase tracking-wider py-3 px-3 whitespace-nowrap">
                Time
              </th>
              <th className="text-left text-xs font-medium text-[#6b7280] uppercase tracking-wider py-3 px-3 whitespace-nowrap">
                Source
              </th>
              <th className="text-left text-xs font-medium text-[#6b7280] uppercase tracking-wider py-3 px-3 whitespace-nowrap">
                Event
              </th>
              <th className="text-left text-xs font-medium text-[#6b7280] uppercase tracking-wider py-3 px-3 whitespace-nowrap">
                Lead / Details
              </th>
              <th className="text-left text-xs font-medium text-[#6b7280] uppercase tracking-wider py-3 px-3 whitespace-nowrap">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {visible.map((entry, i) => (
              <tr
                key={i}
                className={`border-b border-gray-100 ${
                  i % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                }`}
              >
                <td className="py-3 px-3 text-xs text-[#6b7280] whitespace-nowrap">
                  {entry.time}
                </td>
                <td className="py-3 px-3 whitespace-nowrap">
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold ${entry.sourceColor}`}
                  >
                    {entry.source}
                  </span>
                </td>
                <td className="py-3 px-3 whitespace-nowrap">
                  <div className="flex items-center gap-1.5">
                    <i className={`${entry.eventIcon} ${entry.eventIconColor} text-xs`} />
                    <span className="text-xs text-[#374151]">{entry.event}</span>
                  </div>
                </td>
                <td className="py-3 px-3 text-xs text-[#374151] max-w-[220px] truncate">
                  {entry.leadDetail}
                </td>
                <td className="py-3 px-3 whitespace-nowrap">
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                      entry.status === "success"
                        ? "bg-green-50 text-green-700"
                        : "bg-red-50 text-red-600"
                    }`}
                  >
                    {entry.status === "success" ? "Success" : "Error"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filtered.length > visibleCount && (
        <div className="mt-4 flex justify-center">
          <button
            onClick={() => setVisibleCount((prev) => prev + 10)}
            className="px-4 py-2 border border-gray-300 text-sm font-medium text-[#374151] rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap"
          >
            Load More
          </button>
        </div>
      )}

      {filtered.length === 0 && (
        <div className="text-center py-8">
          <p className="text-sm text-[#6b7280]">No activity matching the selected filters</p>
        </div>
      )}
    </div>
  );
}